import React from 'react';
import styled from 'styled-components';

import { ServiceProvider } from '@/modules/Service/ServiceProvider';

import Hero from './components/Hero';
import Services from './components/Services';
import Offers from './components/Offers';
import Dealers from './components/Dealers';

export function ServiceSingle() {
  return (
    <ServiceProvider>
      <Component>
        <Hero />
        <Services />
        <Offers />
        <Dealers />
      </Component>
    </ServiceProvider>
  );
}

const Component = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background: ${(props) => props.theme.white};
`;
